/* eslint-disable react/prop-types */ // TODO: add props
import urlResolver from 'edrolo/utils/URLResolver';

const edroloCentralUrl =
  'https://edrolodocs.atlassian.net/wiki/spaces/KBOPS/overview?homepageId=1816035541';

const edroloZendeskUrl = 'https://help.edrolo.com.au/';

const ProfileNav = ({ profile }) => {
  return (
    <div className="dropdown" id="account-nav">
      <button
        className="btn btn-default dropdown-toggle"
        type="button"
        id="user-name"
        data-toggle="dropdown"
        data-mp-mask
      >
        {profile.get('display_name')}
        &nbsp;
        <span className="caret" />
      </button>
      <ul
        className="dropdown-menu pull-right"
        role="menu"
        aria-labelledby="user-name"
        id="account-options"
      >
        <li id="name" data-mp-mask>
          {profile.get('display_name')}
        </li>
        <li id="email" data-mp-mask>
          {profile.get('email')}
        </li>
        {profile.get('is_staff') ? (
          <>
            <li role="presentation">
              <a
                role="menuitem"
                tabIndex="-1"
                href={urlResolver.getPath('django-admin')}
                className="account-link"
              >
                Admin
              </a>
            </li>
            <li role="presentation">
              <a
                role="menuitem"
                tabIndex="-1"
                href={edroloCentralUrl}
                className="account-link"
              >
                Edrolo Central
              </a>
            </li>
          </>
        ) : null}
        {profile.get('is_poc') || profile.get('is_staff') ? (
          <li role="presentation">
            <a
              role="menuitem"
              tabIndex="-1"
              href={urlResolver.getPath('school')}
              className="account-link"
            >
              My school
            </a>
          </li>
        ) : null}
        {profile.get('is_teacher') ? (
          <li role="presentation">
            <a
              role="menuitem"
              tabIndex="-1"
              href={urlResolver.getPath('classes')}
              className="account-link"
            >
              My classes
            </a>
          </li>
        ) : null}
        <li role="presentation">
          <a
            role="menuitem"
            tabIndex="-1"
            href={urlResolver.getPath('courses-page')}
            className="account-link"
          >
            My subjects
          </a>
        </li>
        <li role="presentation">
          <a
            role="menuitem"
            tabIndex="-1"
            href={urlResolver.getPath('profile')}
            className="account-link"
          >
            My details
          </a>
        </li>
        <li role="presentation">
          <a
            role="menuitem"
            tabIndex="-1"
            href={edroloZendeskUrl}
            className="account-link"
            target="_blank"
          >
            Help
          </a>
        </li>
        <li role="presentation">
          <a role="menuitem" tabIndex="-1" href={urlResolver.getPath('logout')}>
            Sign out
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ProfileNav;
